<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {memberPurchaseOrderStateEnum} from "@/enum/memberPurchaseOrderStateEnum.js"
import YTMemberPurchaseOrder from "@/components/YTMemberPurchaseOrderState/index.vue";
import {listMemberOrder} from "@/api/member/member.js";

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

// 订单状态枚举
const orderState = ref(memberPurchaseOrderStateEnum)

/*搜索功能*/
// 表单数据
const formData = reactive({
  orderNo: null,
  userKeyword: null,
  orderState: null,
  billingCycle: "MONTHLY"
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const param = ref({
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    })
    loading.value = true;
    const res = await listMemberOrder(param.value, formData);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.orderNo = null
  formData.userKeyword = null
  formData.orderState = null
  handleSearch('btnSearch')
}
// 处理改变列表状态
const handleChangeListType = (type) => {
  if (type === formData.billingCycle) return console.log("点击了当前列表，不作操作")
  formData.billingCycle = type
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 表头信息
const headers = ref([
  { title: '订单编号', key: 'orderNo', nowrap: true },
  { title: '商户单号', key: 'paymentNo', nowrap: true },
  { title: '用户ID', key: 'userId', nowrap: true },
  { title: '用户昵称', key: 'nickname', nowrap: true },
  { title: '会员等级', key: 'memberInfo.levelDesc', nowrap: true },
  { title: '联系电话', key: 'phone', nowrap: true },
  { title: '订单状态', key: 'orderState', nowrap: true },
  { title: '购买时间', key: 'paymentTime', nowrap: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

</script>

<template>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.orderNo"
                        placeholder="请输入订单编号"
                        label="订单编号"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.userKeyword"
                        placeholder="用户ID/昵称/手机号"
                        label="用户"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.orderState"
                        placeholder="选择订单状态"
                        variant="outlined"
                        label="订单状态"
                        clearable
                        :items="orderState"
                        item-title="stateName"
                        item-value="stateId"
                    ></v-select>
                  </v-col>
                  <v-col cols="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
            <div class="flex_right">
              <v-btn class="cursor-pointer" :color="formData.billingCycle === 'MONTHLY' ? 'primary' : '#75a2d3'" @click="handleChangeListType('MONTHLY')">月度会员</v-btn>
              <v-btn class="cursor-pointer" style="color: #fff" :color="formData.billingCycle === 'ANNUAL' ? 'warning' : '#fb8c0099'" @click="handleChangeListType('ANNUAL')">年度会员</v-btn>
            </div>
          </template>

          <template v-slot:item.memberInfo.levelDesc="{ item }">
            <el-tag round type="primary" v-if="item.memberInfo.billingCycle === 'MONTHLY'" v-text="item.memberInfo.levelDesc"></el-tag>
            <el-tag round type="warning" color="#fcf8c9" v-if="item.memberInfo.billingCycle === 'ANNUAL'" v-text="item.memberInfo.levelDesc"></el-tag>
          </template>

          <template v-slot:item.orderState="{ item }">
<!--            <YTMemberPurchaseOrder :state="item.orderState"></YTMemberPurchaseOrder>-->
            <el-tag v-if="item.orderStateDesc === '已完成'" round type="success" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '待支付'" round type="warning" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已取消'" round type="info" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else-if="item.orderStateDesc === '已关闭'" round type="info" v-text="item.orderStateDesc"></el-tag>
            <el-tag v-else round type="info">未知状态</el-tag>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSize" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>
